export default __webpack_public_path__ + "4ce8699a76d05ed4311151acc1772b1f.png";